var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "usertags" },
    [
      _c("Filtersearch", {
        ref: "Filtersearchref",
        attrs: { list: _vm.Filtersearchlist, fromdata: _vm.from },
        on: { Refresh: _vm.Refresh, search: _vm.search },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.add(false)
                      },
                    },
                  },
                  [_vm._v("新增")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "auto-table-flex" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", align: "center", label: "ID" },
              }),
              _c("el-table-column", {
                attrs: { prop: "name", align: "center", label: "标签名称" },
              }),
              _c("el-table-column", {
                attrs: { prop: "remarks", align: "center", label: "备注" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "member_count",
                  align: "center",
                  label: "绑定用户",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "operate_name",
                  align: "center",
                  label: "添加人",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "create_time",
                  align: "center",
                  label: "添加时间",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "is_tdc_show_txt",
                  align: "center",
                  label: "是否仓可见",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "type_txt", align: "center", label: "标签类型" },
              }),
              _c("el-table-column", {
                attrs: { prop: "order_no", align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.type == 2
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.relation(scope.row)
                                  },
                                },
                              },
                              [_vm._v("关联用户")]
                            )
                          : _vm._e(),
                        scope.row.type == 2
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("清空")]
                            )
                          : _vm._e(),
                        scope.row.type == 2
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.add(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.from.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("commonusertagadd", {
        ref: "commonusertagadd",
        on: { dialogVisibleChange: _vm.dialogVisibleChange },
      }),
      _c("commonusertagrelation", {
        ref: "commonusertagrelation",
        on: { dialogVisibleChange: _vm.dialogVisibleChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }